import ClientAction from '@/services/Action/ClientAction';
import * as types from '../mutation-types';
import Vue from 'vue';
import { forEach } from 'lodash';

// state
export const state = {
  unassigned: null,
  pending: null,
  noAccess: null,
  updates: null,
};

// mutations
export const mutations = {
  [types.FETCH_CLIENT_ACTION_COUNTS_FAILURE](state) {
    state = {
      unassigned: null,
      pending: null,
      noAccess: null,
      updates: null,
    };
  },

  [types.FETCHING_CLIENT_ACTION_COUNTS](state) {},

  [types.FETCH_CLIENT_ACTION_COUNTS_SUCCESS](state, counts) {
    forEach(state, (value, key) => {
      Vue.delete(state, key);
    });

    forEach(counts, (value, key) => {
      Vue.delete(state, key);
      Vue.set(state, key, value);
    });
  },

  [types.RESET_CLIENT_ACTION_COUNTS](state) {
    forEach(state, (value, key) => {
      Vue.delete(state, key);
    });
  },
};

// actions
export const actions = {
  /**
   * @param commit
   * @param rootState
   * @returns {Promise<void>}
   */
  async refreshClientActionCounts({ commit, rootState }) {
    commit(types.FETCHING_CLIENT_ACTION_COUNTS);


    let tenure = rootState.propertyTenure.propertyTenure;
    if (!tenure) {
      tenure = 'All Tenures';
    }

    try {
      const response = await ClientAction.getCounts(tenure);
      commit(types.FETCH_CLIENT_ACTION_COUNTS_SUCCESS, response.data.data);
    } catch (e) {
      commit(types.FETCH_CLIENT_ACTION_COUNTS_FAILURE);
    }
  },
};

// getters
export const getters = {
  clientActionCount: state => status => state[status],
  clientActionCounts: state => state
};
